import { DynamicImageWidthPipe } from './dynamic-image.pipe';

export const DYNAMIC_IMAGE_PIPE_DECLARATIONS = [DynamicImageWidthPipe];

export * from './dynamic-image.pipe';
